type Level = 'debug' | 'info' | 'warn' | 'error';

const LEVELS: Level[] = ['debug', 'info', 'warn', 'error'];

// production builds log warnings and errors only
const THRESHOLD: Level = import.meta.env.PROD ? 'warn' : 'debug';

function enabled(level: Level): boolean {
	return LEVELS.indexOf(level) >= LEVELS.indexOf(THRESHOLD);
}

function write(level: Level, args: unknown[]): void {
	if (!enabled(level)) {
		return;
	}
	console[level](`${level} >`, ...args);
}

/** Console logger, replaces vuejs-logger (debug and info are dropped in production builds). */
export const log = {
	debug: (...args: unknown[]) => write('debug', args),
	info: (...args: unknown[]) => write('info', args),
	warn: (...args: unknown[]) => write('warn', args),
	error: (...args: unknown[]) => write('error', args),
};
